import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-10 align-items-center bg-white card-body py-10" }
const _hoisted_2 = { class: "row mb-10" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-xl-4 mb-15 pe-5\"><h4 class=\"text-gray-800 mb-0\">Referral Program</h4><p class=\"fs-7 fw-semibold text-gray-600 py-4 mb-0\"> Review your payouts, commission structure, price breakdown </p><a href=\"#\" class=\"btn btn-sm btn-light btn-active-light-primary fw-bold mb-5\">Commision Structure</a><br> <a href=\"#\" class=\"btn btn-sm btn-light btn-active-light-primary fw-bold\">Earning Details</a></div>", 1)
const _hoisted_4 = { class: "col-xl-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 mb-0" }, "Referral Code URL", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fs-7 fw-semibold text-gray-600 py-4 m-0" }, " Send your custom invitation url to your referral leads. Leads that convert to customers are tracked when sign-up is completed. Converted leads will display in your customer list. ", -1)
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  href: "#",
  class: "btn btn-sm btn-light fw-bold",
  ref: "copyButtonRef",
  id: "referral_link_copy_button",
  "data-clipboard-target": "#referral_link_input"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "card card-dashed flex-center min-w-175px my-3 p-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-semibold text-dark pb-1 px-2" }, "Net Earnings", -1)
const _hoisted_13 = { class: "fs-2x fw-bold d-flex justify-content-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("$ ")
const _hoisted_15 = {
  "data-kt-countup": "true",
  "data-kt-countup-value": "63,240.00",
  class: "counted",
  "data-kt-initialized": "1"
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "card card-dashed flex-center min-w-175px my-3 p-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-semibold text-dark pb-1 px-2" }, "Balance", -1)
const _hoisted_19 = { class: "fs-2x fw-bold d-flex justify-content-center" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("$ ")
const _hoisted_21 = {
  "data-kt-countup": "true",
  "data-kt-countup-value": "8,530.00",
  class: "counted",
  "data-kt-initialized": "1"
}
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "card card-dashed flex-center min-w-175px my-3 p-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-semibold text-dark pb-1 px-2" }, "Customers", -1)
const _hoisted_25 = { class: "fs-2x fw-bold d-flex justify-content-center" }
const _hoisted_26 = {
  "data-kt-countup": "true",
  "data-kt-countup-value": "2,600",
  class: "counted",
  "data-kt-initialized": "1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TwoFactorAuthModal = _resolveComponent("TwoFactorAuthModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              ref: "inputRef",
              id: "referral_link_input",
              type: "text",
              class: "form-control form-control-solid me-3 flex-grow-1 fs-6 p-2",
              name: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referralDetails.referral_code) = $event))
            }, null, 512), [
              [_vModelText, _ctx.referralDetails.referral_code]
            ]),
            _createElementVNode("a", _hoisted_8, "Copy", 512)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.referralDetails.net_amount), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.referralDetails.balance), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.referralDetails.links_sent), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_TwoFactorAuthModal)
  ], 64))
}